module.exports = __webpack_public_path__ + "img/medal2.739d5ff4.png";